import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.93 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.36 1.91c-1.42-.11-3.01.6-3.85 2.29-.79-1.64-2.33-2.34-3.7-2.26-1.8.1-3.74 1.54-3.74 4.46-.01 5.22 6.87 9.45 7.16 9.63a.521.521 0 0 0 .55-.02c.29-.21 7.15-5.12 7.15-9.96 0-2.68-1.85-4.03-3.57-4.14z"
    }, null, -1)
  ])))
}
export default { render };